import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClienteAnaliseMercadoRAPFormTableModule } from '../../rap/components/form-table';

import { ClienteAnaliseMercadoRAPViewComponent } from './cliente-analise-mercado-rap-view.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoRAPFormTableModule
    ],
    declarations: [
        ClienteAnaliseMercadoRAPViewComponent
    ],
    exports: [
        ClienteAnaliseMercadoRAPViewComponent
    ]
})
export class ClienteAnaliseMercadoRAPViewModule { }
